import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ae9d4068"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "points" }
const _hoisted_2 = { class: "points_row" }
const _hoisted_3 = { class: "points_cell how-it-works" }
const _hoisted_4 = { class: "how-it-works_content" }
const _hoisted_5 = { class: "how-it-works_header" }
const _hoisted_6 = { class: "how-it-works_list" }
const _hoisted_7 = { class: "how-it-works_item" }
const _hoisted_8 = /*#__PURE__*/_createStaticVNode("<div class=\"how-it-works_icon\" data-v-ae9d4068><svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-ae9d4068><g clip-path=\"url(#clip0_2088_9767)\" data-v-ae9d4068><path d=\"M10.0001 15.217L6.0143 17.4481C5.2697 17.8649 4.37875 17.2176 4.54502 16.3806L5.43509 11.9003L2.08106 8.79891C1.45453 8.21956 1.79481 7.17215 2.64221 7.07165L7.17843 6.53366L9.09205 2.38539C9.44948 1.61057 10.5507 1.61057 10.9081 2.38539L12.8218 6.53366L17.358 7.07165C18.2054 7.17215 18.5457 8.21956 17.9191 8.79891L14.5651 11.9003L15.4552 16.3806C15.6214 17.2176 14.7305 17.8649 13.9859 17.4481L10.0001 15.217Z\" fill=\"#B03FFB\" data-v-ae9d4068></path></g><defs data-v-ae9d4068><clipPath id=\"clip0_2088_9767\" data-v-ae9d4068><rect width=\"20\" height=\"20\" fill=\"white\" data-v-ae9d4068></rect></clipPath></defs></svg></div>", 1)
const _hoisted_9 = { class: "how-it-works_item" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "how-it-works_icon" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M13.763 2.5C16.6371 2.5 18.3334 4.15383 18.3334 6.98483H14.8075V7.01372C13.1711 7.01372 11.8445 8.30707 11.8445 9.9025C11.8445 11.4979 13.1711 12.7913 14.8075 12.7913H18.3334V13.0513C18.3334 15.8462 16.6371 17.5 13.763 17.5H6.23712C3.36304 17.5 1.66675 15.8462 1.66675 13.0513V6.94872C1.66675 4.15383 3.36304 2.5 6.23712 2.5H13.763ZM17.7112 8.22701C18.0548 8.22701 18.3334 8.49861 18.3334 8.83365V10.9425C18.3294 11.2759 18.0532 11.5452 17.7112 11.5491H14.8742C14.0457 11.56 13.3213 11.007 13.1334 10.2203C13.0393 9.73191 13.1714 9.22797 13.4943 8.84351C13.8172 8.45906 14.2979 8.2334 14.8075 8.22701H17.7112ZM15.2075 9.20197H14.9334C14.7651 9.20004 14.6031 9.26387 14.4834 9.3792C14.3637 9.49453 14.2964 9.65177 14.2964 9.81584C14.2964 10.16 14.5804 10.4402 14.9334 10.4441H15.2075C15.5593 10.4441 15.8445 10.1661 15.8445 9.82306C15.8445 9.48004 15.5593 9.20197 15.2075 9.20197ZM10.3186 5.74266H5.6149C5.26594 5.74263 4.98192 6.01633 4.97786 6.35652C4.97786 6.70073 5.26188 6.98088 5.6149 6.98483H10.3186C10.6704 6.98483 10.9556 6.70676 10.9556 6.36375C10.9556 6.02073 10.6704 5.74266 10.3186 5.74266Z",
      fill: "#B03FFB"
    })
  ])
], -1))
const _hoisted_11 = { class: "how-it-works_actions" }
const _hoisted_12 = {
  key: 0,
  class: "points_row"
}
const _hoisted_13 = { class: "faq" }
const _hoisted_14 = { class: "faq_row" }
const _hoisted_15 = { class: "faq_header" }
const _hoisted_16 = { class: "faq_row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_points_card = _resolveComponent("points-card")!
  const _component_ac_button = _resolveComponent("ac-button")!
  const _component_ac_expansion_panel = _resolveComponent("ac-expansion-panel")!
  const _component_ac_expansion_panels = _resolveComponent("ac-expansion-panels")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_points_card, {
        class: "points_cell",
        points: _ctx.userScoreAmount
      }, null, 8, ["points"]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('pointsPage.howItWorks')), 1),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _createTextVNode(" " + _toDisplayString(_ctx.$t('pointsPage.getPointsFor')), 1)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _createTextVNode(" " + _toDisplayString(_ctx.$t('pointsPage.howManyPoints', { count: _ctx.countPointsToDebit })), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_ac_button, {
            class: "how-it-works_action",
            variant: "text",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handlerMoreDetail()))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('More')), 1)
            ]),
            _: 1
          })
        ])
      ])
    ]),
    (_ctx.isShowFaq)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.$t('pointsPage.faqTitle')), 1)
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createVNode(_component_ac_expansion_panels, { class: "faq_panels" }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.faq, (q, key) => {
                    return (_openBlock(), _createBlock(_component_ac_expansion_panel, {
                      key: `ac-expansion-panel-${key}`,
                      panel: q,
                      fields: { title: 'question', text: 'answer' },
                      "expand-icon": { expand: 'plus', collapse: 'minus' }
                    }, null, 8, ["panel"]))
                  }), 128))
                ]),
                _: 1
              })
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}